// Sponsor directory. Add a new object here to publish a new sponsor —
// no layout changes required.

export const sponsors = [
  {
    id: "parlay-syndicate",
    name: "Parlay Syndicate",
    logo:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_odd-converter/artifacts/fui7lk61_New_PS_Logo_-_PNG.PNG",
    alt: "Parlay Syndicate Sponsor Logo",
    description:
      "Join one of the fastest-growing sports betting communities featuring premium picks, betting education, exclusive content, and an active member community.",
    url: "https://whop.com/parlay-syndicate?a=24michaelcook",
  },
];
